import React, { forwardRef } from "react";

import { StoreSearchMapComponent } from "./storeSearchMap.component";

type StoreSearchMapContainerProps = {};

const StoreSearchMapContainer = forwardRef<
    HTMLDivElement,
    StoreSearchMapContainerProps
>(({}: StoreSearchMapContainerProps, ref) => {
    return <StoreSearchMapComponent ref={ref} />;
});

export { StoreSearchMapContainer };
